import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-confirm-checkbox-dialog',
  templateUrl: './delete-confirm-checkbox-dialog.component.html',
  styleUrls: ['./delete-confirm-checkbox-dialog.component.scss']
})
export class DeleteConfirmCheckboxDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteConfirmCheckboxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any) { }

  ngOnInit() {
  }

  onCloseClick() {
    this.dialogRef.close(false);
}

onConfirmDeleteClick() {
    this.dialogRef.close(true);
}

}
